// extracted by mini-css-extract-plugin
export default {"mediumBubbleContainer":"mediumbubble_mediumBubbleContainer__A8c6z"};